/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FaxProvider } from './FaxProvider';
import {
    FaxProviderFromJSON,
    FaxProviderFromJSONTyped,
    FaxProviderToJSON,
} from './FaxProvider';

/**
 * 
 * @export
 * @interface ClinicConfiguration
 */
export interface ClinicConfiguration {
    /**
     * 
     * @type {string}
     * @memberof ClinicConfiguration
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ClinicConfiguration
     */
    diagnostics_graph_token?: string;
    /**
     * 
     * @type {string}
     * @memberof ClinicConfiguration
     */
    lifelabs_contract?: string;
    /**
     * 
     * @type {string}
     * @memberof ClinicConfiguration
     */
    fax_cover?: string;
    /**
     * 
     * @type {FaxProvider}
     * @memberof ClinicConfiguration
     */
    fax_provider?: FaxProvider;
}

/**
 * Check if a given object implements the ClinicConfiguration interface.
 */
export function instanceOfClinicConfiguration(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ClinicConfigurationFromJSON(json: any): ClinicConfiguration {
    return ClinicConfigurationFromJSONTyped(json, false);
}

export function ClinicConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClinicConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'diagnostics_graph_token': !exists(json, 'diagnostics_graph_token') ? undefined : json['diagnostics_graph_token'],
        'lifelabs_contract': !exists(json, 'lifelabs_contract') ? undefined : json['lifelabs_contract'],
        'fax_cover': !exists(json, 'fax_cover') ? undefined : json['fax_cover'],
        'fax_provider': !exists(json, 'fax_provider') ? undefined : FaxProviderFromJSON(json['fax_provider']),
    };
}

export function ClinicConfigurationToJSON(value?: ClinicConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'diagnostics_graph_token': value.diagnostics_graph_token,
        'lifelabs_contract': value.lifelabs_contract,
        'fax_cover': value.fax_cover,
        'fax_provider': FaxProviderToJSON(value.fax_provider),
    };
}

